import { render, staticRenderFns } from "./BuyoutBatchItemCreate.vue?vue&type=template&id=664f9441"
import script from "./BuyoutBatchItemCreate.vue?vue&type=script&lang=js"
export * from "./BuyoutBatchItemCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports